import { Paper, Tabs, Tab, Typography, Button, makeStyles, Table, TableRow, TableCell, TableHead, TableBody, CircularProgress, Container, Box, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";

import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    TimePicker
} from '@material-ui/pickers';
import dateFormat from "dateformat";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { sortingInstrumentsPredicate } from "@frontend/pb-calculations";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(4),
        textAlign: 'left',
        margin: theme.spacing(4),
        overflowX: 'auto'
    },
    title: {
        fontFamily: "Roboto Condensed",
        fontWeight: theme.typography.fontWeightBold
    },
    subtitle: {
        fontFamily: "Roboto Condensed",
    },
    content: {
        fontFamily: "Ubuntu",
    },
    changa: {
        fontFamily: "Changa",
        fontWeight: 'bold'
    },
    table_header: {
        fontFamily: 'Changa',
        fontWeight: 'bold',
    },
}));


export default function OrderBook(props) {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    let [loading, setLoading] = useState(false);
    let [currency, setCurrency] = useState('BTC');
    let [timeSpent, setTimeSpent] = useState(0);
    let [tabIndex, setTabIndex] = useState(0);

    let [symbols, setSymbols] = useState([]);

    let [futures, setFutures] = useState([]);

    const [selectedDate, setSelectedDate] = React.useState(new Date('2020-07-01T01:01:01'));

    const handleDateChange = (date) => {
        if (!isNaN(date)) {
            setSelectedDate(date);
        }
        // console.log(dateFormat(date, "yyyy-mm-dd HH:MM:ss"));
    };

    async function getOrderBook() {

        setLoading(true);
        var MS_PER_SECOND = 1000;
        var fromDate = new Date(selectedDate - 15 * MS_PER_SECOND);

        try {
            const startTime = Date.now()
            const { data: { options, futures } } = await axios.post(`${process.env.REACT_APP_HOST}/orderbook`, {
                from: dateFormat(fromDate, "yyyy-mm-dd HH:MM:ss"),
                to: dateFormat(selectedDate, "yyyy-mm-dd HH:MM:ss"), currency
            })


            setSymbols(options.sort((a, b) => sortingInstrumentsPredicate(a.symbol, b.symbol)));
            setFutures(futures.sort((a, b) => sortingInstrumentsPredicate(a.symbol, b.symbol)));
            const endTime = Date.now()
            setTimeSpent((endTime - startTime) / 1000)
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Error loading data', { variant: 'error', autoHideDuration: 1000 });
        } finally {
            setLoading(false);
        }
    }


    return (
        <Paper className={classes.paper}>
            <div style={{ marginTop: 20, textAlign: "right" }}>


                {(props.isLoggedIn) && <div style={{ marginTop: 20 }} >
                    <Button variant="contained" color="secondary" type="submit">
                        Logout
                    </Button>
                </div>}

                {(!props.isLoggedIn) && <div style={{ marginTop: 20 }} >
                    <Button variant="contained" color="secondary" type="submit" href="/signin">
                        Login
                    </Button>
                </div>}
            </div>

            <Tabs value={tabIndex} variant="fullWidth" onChange={(event, newValue) => { setTabIndex(newValue); }}>
                <Tab label="Options/Futures Chain Data" />
                <Tab label="User Trade Volumes" />
            </Tabs>

            <div style={{ marginTop: 30 }}>
                <Typography className={classes.changa} variant="h5" gutterBottom>
                    Deribit | Options Chain Order Book Data
                </Typography>
                <hr />

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container justifyContent="space-around">
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="normal"
                            id="date-picker-inline"
                            label="Date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                        <TimePicker
                            id="time-picker"
                            ampm={false}
                            openTo="hours"
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            label="With seconds"
                            value={selectedDate}
                            onChange={handleDateChange}
                        />

                        <RadioGroup row aria-label="position" name="position" defaultValue="BTC" onChange={(event) => {
                            setCurrency(event.target.value);
                        }}>
                            <FormControlLabel value="BTC" control={<Radio color="primary" />} label={<Typography className={classes.changa}>BTC</Typography>} />
                            <FormControlLabel value="ETH" control={<Radio color="primary" />} label={<Typography className={classes.changa}>ETH</Typography>} />
                        </RadioGroup>

                        <Button variant="contained" style={{ maxHeight: 40 }} color="primary" type="submit" onClick={getOrderBook} disabled={loading}>
                            Fetch Data
                        </Button>

                        {/* <div style={{ marginTop: 20 }}> */}
                        {/* <TextField size="small" id="outlined-basic" type="number" defaultValue={5} label="Lookback Duration" variant="outlined" fullWidth /> */}
                        {/* </div> */}

                    </Grid>


                </MuiPickersUtilsProvider>
                <Container justifyContent="center" align="center" textAlign="center">
                    {loading &&

                        <Box>
                            <Typography className={classes.changa} color="secondary">Loading, Please Wait...</Typography>
                            <CircularProgress />
                        </Box>
                    }
                    <Box>
                        <Typography className={classes.changa} color="primary">
                            Order book data fetched for {dateFormat(selectedDate, "yyyy-mm-dd HH:MM:ss")}
                        </Typography>

                        <Typography className={classes.changa} color="secondary">
                            Time spent: {timeSpent} seconds
                        </Typography>

                    </Box>
                </Container>
                {
                    (!loading && futures.length > 0) && <Paper className={classes.paper}>
                        <Typography className={classes.changa} variant="h6">
                            Futures
                        </Typography>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead >
                                <TableRow >
                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Instrument</TableCell>
                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Open Interest</TableCell>
                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Last Price</TableCell>
                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Index Price</TableCell>
                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Mark Price</TableCell>
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {
                                    futures.map((row) => {
                                        return (<TableRow key={row.symbol}>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.symbol}</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.openInterest}</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.lastPrice}</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.indexPrice}</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.markPrice}</TableCell>

                                        </TableRow>);
                                    })
                                }
                            </TableBody>
                        </Table>
                    </Paper>
                }
                {
                    (!loading) &&
                    symbols.map((symbol) => {
                        return (
                            <>
                                <Grid container justifyContent="space-around">
                                    <Typography className={classes.changa} variant="h6">
                                        {symbol.symbol}
                                    </Typography>
                                    <Typography className={classes.changa}>
                                        Underlying Price: {symbol.underlyingPrice}
                                    </Typography>
                                </Grid>
                                <Table className={classes.table} size="small" aria-label="a dense table">
                                    <TableHead >
                                        <TableRow >
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Last Price</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid Size</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid IV</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Mark</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask IV</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask Size</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Open Interest</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Delta</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Mark_iv</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">Strike</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Last Price</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid Size</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid IV</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Bid</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Mark</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask IV</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Ask Size</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Open Interest</TableCell>
                                            <TableCell className={classes.table_header} style={{ width: 100 }} align="center">Delta</TableCell>

                                        </TableRow>

                                    </TableHead>
                                    <TableBody>
                                        {
                                            symbol.symbolData.map((row) => {
                                                return (<TableRow key={row.strikePrice}>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.lastPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.bidAmount}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.bidIV}%</TableCell>
                                                    <TableCell className={classes.table_header} style={((row.callData?.bidPrice && row.callData?.bidPrice > row.callData?.markPrice) ? { backgroundColor: "green" } : { color: "green" })} align="center">{row.callData?.bidPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.markPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={((row.callData?.askPrice && row.callData?.askPrice < row.callData?.markPrice) ? { backgroundColor: "red" } : { color: "red" })} align="center">{row.callData?.askPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.askIV}%</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.askAmount}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.openInterest}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.callData?.delta}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }}>{row.callData?.mark_iv}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100, backgroundColor: "#E8EBEA" }} align="center">{row.strikePrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.lastPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.bidAmount}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.bidIV}%</TableCell>
                                                    <TableCell className={classes.table_header} style={((row.putData?.bidPrice && row.putData?.bidPrice > row.putData?.markPrice) ? { backgroundColor: "green" } : { color: "green" })} align="center">{row.putData?.bidPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 50 }} align="center">{row.putData?.markPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={((row.putData?.askPrice && row.putData?.askPrice < row.putData?.markPrice) ? { backgroundColor: "red" } : { color: "red" })} align="center">{row.putData?.askPrice}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.askIV}%</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.askAmount}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.openInterest}</TableCell>
                                                    <TableCell className={classes.table_header} style={{ width: 100 }} align="center">{row.putData?.delta}</TableCell>
                                                </TableRow>);
                                            })
                                        }
                                    </TableBody>
                                </Table>
                                <hr style={{ marginTop: 50, marginBottom: 50 }} />
                            </>
                        );
                    })
                }
            </div>
        </Paper>);


}



